import BoardContainer from "../board/BoardContainer";

const categories = [
  { postType: 'PT01', title: '커뮤니티', sectionTitle: '커뮤니티' },
  { postType: 'PT011', title: '자유 광장', sectionTitle: '자유 광장' },
  { postType: 'PT010', title: '익명 광장', sectionTitle: '익명 광장' },
  { postType: 'PT012', title: '셀러 광장', sectionTitle: '셀러 광장' },
];

const Community = ({ postType='PT01' }) => {
  return (
    <BoardContainer categories={categories} postType={postType} />
  );
}

export default Community;